module.exports = __webpack_public_path__ + "img/image.a66cd48a.png";